export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      {/* 刊头装饰线 */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-primary-500 via-secondary-400 to-accent-500"></div>

      <div className="mx-auto grid max-w-6xl items-center gap-8 px-4 py-12 md:gap-10 md:px-6 md:py-16 lg:grid-cols-[1.15fr_0.85fr]">
        {/* 文案优先 */}
        <div className="relative z-10">
          <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-semibold tracking-wide text-foreground-500">
            <span className="flex items-center gap-1 text-primary-600">
              <i className="ri-apps-2-line"></i>CHIGUA · 下载渠道总入口
            </span>
            <span className="hidden text-background-400 sm:inline">|</span>
            <span className="hidden text-foreground-400 sm:inline">2026 第 09 期 · 本周更新 12 个</span>
          </p>

          <h1 className="mt-5 font-display text-4xl font-black leading-tight text-foreground-950 md:text-6xl">
            吃瓜软件
            <span className="mt-1 block text-2xl font-black text-primary-600 md:text-4xl">
              安装包大全 · 一页全收录
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            安卓下载、苹果安装、最新版本一步到位。所有安装包官网直发并经过安全校验，
            安全下载不吃亏、快速上手不迷路——收藏这一篇，随时拿到最新吃瓜软件。
          </p>

          {/* 数据条 */}
          <dl className="mt-8 grid max-w-xl grid-cols-3 divide-x divide-background-300/70 rounded-xl border border-background-200 bg-background-50 px-2 py-4 text-center">
            {[
              ["394", "收录版本", "ri-stack-line"],
              ["86,000+", "周活下载", "ri-download-cloud-2-line"],
              ["100%", "安全检测", "ri-shield-check-line"],
            ].map(([num, label, icon]) => (
              <div key={label} className="px-2">
                <dt className="flex items-center justify-center gap-1 text-xs text-foreground-400">
                  <i className={icon}></i>
                  <span className="whitespace-nowrap">{label}</span>
                </dt>
                <dd className="mt-1 font-display text-xl font-bold text-primary-600 md:text-2xl">{num}</dd>
              </div>
            ))}
          </dl>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#hot"
              className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line"></i>
              浏览本周热榜
            </a>
            <a
              href="#channels"
              className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-download-2-line"></i>
              进入安卓下载通道
            </a>
          </div>
        </div>

        {/* 视觉陪衬 */}
        <div className="relative mx-auto w-full max-w-sm lg:max-w-none">
          <div className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-50">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20app%20download%20channel%20hero%20illustration%20modern%203d%20smartphone%20with%20soft%20coral%20red%20and%20warm%20cream%20background%20floating%20install%20package%20boxes%20and%20a%20fresh%20watermelon%20slice%20minimal%20clean%20product%20mockup%20warm%20lighting%20high%20detail&width=720&height=760&seq=chigua-hero-cover&orientation=portrait"
              alt="吃瓜软件下载渠道安装包演示图"
              className="h-full w-full object-cover"
            />
            {/* 版本角标 */}
            <div className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-primary-500/95 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-verified-badge-fill"></i>
              最新版本 v3.8.2
            </div>
            <div className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-accent-500/95 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-shield-check-fill"></i>
              已通过安全校验
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}